import { useLazyQuery as u } from "@apollo/client";
import { publicAccountSchema as l } from "../../deserialize/yup/account.js";
import { deserializeData as m } from "../../graphql/deserialize/index.js";
import p from "../../graphql/query/getBelievedInviter.js";
import { useState as d, useCallback as f } from "react";
const z = () => {
  const [t, { loading: a }] = u(p), [r, o] = d(null);
  return {
    fetch: f(
      async (s) => {
        const { id: c, address: n } = s, i = await t({
          variables: { id: c, address: n }
        }), e = m(
          i,
          l
        );
        return o(e), e;
      },
      [t]
    ),
    data: r,
    loading: a
  };
};
export {
  z as default
};
//# sourceMappingURL=useGetBelievedInviter.js.map
